import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export const LeftGrid = styled(Grid)`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;

export const CancelButton = styled(Button)`
  margin-right: 10px;
  background-color: #262626;
`;

export const DeleteButton = styled(Button)`
  margin-right: 10px;
  background-color: #262626;
`;

export const SaveButton = styled(Button)`
  background-color: #262626;
`;

export const LabelTypo = styled(Typography)`
  color: #c9cccf;
`;

export const SaveButtonEpisode = styled(Button)`
  &.Mui-disabled {
    color: #a9a3a3;
    background-color: #ddd7d7;
  }
`;

export const GridContainer = styled(Grid)`
  padding: 5px 0px;
  align-items: center;
`;

export const NoteHeading = styled(Typography)`
  color: #000000;
`;

export const DataGridContainer = styled(Box)`
  height: 60vh;
`;

export const DialogHeader = styled(Box)`
  display: flex;
  z-index: 2;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  top: 0px;
  position: sticky;
  background-color: #ffffff;
`;

export const DialogHeading = styled(Typography)`
  color: #1890ff;
`;

export const ButtonWrapper = styled(Box)`
  display: flex;
  justify-content: end;
  width: -webkit-fill-available;
`;

export const GridSection = styled(Grid)`
  justify-content: center;
  margin-bottom: 10px;
`;

export const GridLeft = styled(Grid)`
  border: 1px solid;
`;

export const GridEleven = styled(Grid)`
  border-top: 1px solid;
  border-left: 1px solid;
  border-right: 1px solid;
`;

export const GridRight = styled(Grid)`
  border-top: 1px solid;
  border-bottom: 1px solid;
  border-right: 1px solid;
`;

export const PrintButtonGrid = styled(Grid)`
  padding-top: 8px;
  justify-content: right;
`;